import { render, staticRenderFns } from "./ApplicableVat.vue?vue&type=template&id=f4911e20&"
import script from "./ApplicableVat.vue?vue&type=script&lang=ts&"
export * from "./ApplicableVat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports